export default __webpack_public_path__ + "static/media/hyena.563c234c.png";